import React, { Fragment, useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_ENSENANZA,
  UPDATE_ENSENANZA,
} from '../../graphql/actions/ensenanza';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput.js';
import Button from '../UI/CustomButtons/Button.js';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const useStyles = makeStyles(sectionAddStyle);
const editorConfiguration = {
  language: 'es',
};

const EnseñanzaEdt = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTipo, setFormTipo] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [edtForm, setEdtForm] = useState({
    tipo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 10, max: 15 })],
    },
    contenido: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of edtForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'tipo') {
        if (isValid) setFormTipo('success');
        else setFormTipo('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
    }

    const updatedForm = {
      ...edtForm,
      [input]: {
        ...edtForm[input],
        valid: isValid,
        value: value,
      },
    };

    let count = 3;
    let formIsValid = true;
    for (const inputName in updatedForm) {
      //formIsValid = formIsValid && updatedForm[inputName].valid;
      if (updatedForm[inputName].valid) count -= 1;
    }

    //console.log(count);
    if (count <= 2) formIsValid = true;
    else formIsValid = false;

    setEdtForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const redirectToEnsenanzas = (data) => {
    //console.log(data);
    if (data.updateEnsenanza) props.history.push('/enseñanzas');
    else console.log('Error editando la enseñanza.');
  };

  const {
    loading: loadingEnsenanza,
    error: errorEnsenanza,
    data: dataEnsenanza,
  } = useQuery(GET_ENSENANZA, {
    variables: {
      id: props.match.params.id,
    },
    skip: !props.match.params.id,
    errorPolicy: 'all',
  });

  const [
    editEnsenanza,
    {
      loading: loadingEdtEnsenanza,
      error: errorEdtEnsenanza,
      data: dataEdtEnsenanza,
    },
  ] = useMutation(UPDATE_ENSENANZA, {
    errorPolicy: 'all',
    //update: updateCacheEdt,
    onCompleted: (data) => redirectToEnsenanzas(data),
  });

  const editarHandler = (event) => {
    event.preventDefault();

    const ensenanzaData = {};
    for (let i in edtForm) {
      if (edtForm[i].value === '') continue;
      else ensenanzaData[i] = edtForm[i].value;
    }

    //console.log(ensenanzaData);

    editEnsenanza({
      variables: {
        input: {
          id: props.match.params.id,
          tipo: ensenanzaData.tipo,
          resumen: ensenanzaData.resumen,
          contenido: ensenanzaData.contenido,
        },
      },
    });
  };

  let seccionTitulo = null;
  let seccionButton = null;
  let seccionFormulario = null;
  let showNotification = null;

  if (loadingEnsenanza) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />;
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = null;
    seccionFormulario = null;
  }
  if (loadingEdtEnsenanza) seccionButton = <Spinner color='gray' />;

  if (errorEnsenanza) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Error buscando la enzeñanza.</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = null;
    seccionFormulario = null;

    showNotification = errorEnsenanza.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorEnsenanza ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorEdtEnsenanza) {
    showNotification = errorEdtEnsenanza.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorEdtEnsenanza ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataEnsenanza && dataEnsenanza.getEnsenanza) {
    const { getEnsenanza } = dataEnsenanza;
    //console.log(getEnsenanza);
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Editar Enseñanza</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = (
      <GridContainer>
        <GridItem
          md={4}
          sm={4}
          className={classNames(
            classes.mrAuto,
            classes.mlAuto,
            classes.textCenter
          )}
        >
          <Button type='submit' color='dark' round disabled={!formIsValid}>
            Editar Enseñanza
          </Button>
        </GridItem>
      </GridContainer>
    );

    seccionFormulario = (
      <div id='formularioEdt'>
        <GridContainer>
          <GridItem
            md={8}
            sm={8}
            className={classNames(classes.mrAuto, classes.mlAuto)}
          >
            <form onSubmit={editarHandler}>
              <GridContainer>
                <GridItem md={12} sm={12} key={getEnsenanza._id}>
                  <CustomInput
                    labelText='Tipo de Enseñanza (*)'
                    success={formTipo === 'success'}
                    error={formTipo === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'tipo');
                      },
                      placeholder: getEnsenanza.tipo,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Resumen (De 10 a 15 palabras)'
                    success={formResumen === 'success'}
                    error={formResumen === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'resumen');
                      },
                      multiline: true,
                      rows: 6,
                      placeholder: getEnsenanza.resumen,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <div className={classes.control}>
                    <p className={classes.label}>Contenido</p>
                    <CKEditor
                      //disabled={true}
                      editor={ClassicEditor}
                      data={getEnsenanza.contenido}
                      config={editorConfiguration}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        //console.log('Editor is ready to use!', editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        inputChangedHandler(data, 'contenido');
                        //console.log({ event, editor, data });
                      }}
                    />
                  </div>
                </GridItem>
              </GridContainer>
              {seccionButton}
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (dataEdtEnsenanza && dataEdtEnsenanza.updateEnsenanza) {
    const { updateEnsenanza } = dataEdtEnsenanza;
    if (updateEnsenanza.success && updateEnsenanza.code === '201') {
      showNotification = (
        <Notification
          key={updateEnsenanza.code}
          mostrar={updateEnsenanza.success ? true : false}
          msg={updateEnsenanza.message}
          stt={updateEnsenanza.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(EnseñanzaEdt);
